// extracted by mini-css-extract-plugin
export var divider = "_cv-7";
export var itemsToggle = "_cv-8";
export var mergeModal = "_cv-1";
export var optionCard = "_cv-4";
export var radioGroup = "_cv-6";
export var radioOption = "_cv-0";
export var selected = "_cv-5";
export var shipmentOptions = "_cv-2";
export var tableOptions = "_cv-3";